import request from "./request";
/**
 * 增加用户与AppId绑定关系
 * @param userName
 * @param appId
 */
export async function addPlayerAppIdBind(data) {
  return await request.post("/spin/dataBusiness/addPlayerAppIdBind", data);
}

/**
 * 删除用户与AppId绑定关系
 * @param userName
 * @param appId
 */
export async function deletePlayerAppIdBind(data) {
  return await request.post("/spin/dataBusiness/deletePlayerAppIdBind", data);
}
